import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-load-panel',
  templateUrl: './load-panel.component.html',
  styleUrls: ['./load-panel.component.scss'],
})
export class LoadPanelComponent {
  private _loadingVisible = false;
  @Input() set loadingVisible(value: boolean) {
    this._loadingVisible = value;
  }
  get loadingVisible(): boolean {
    return this._loadingVisible;
  }
  @Input() destination: string = '';
}
